function $7697c7b09009403d$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $5cacaf716aa5a0bc$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $7697c7b09009403d$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $5cacaf716aa5a0bc$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $7697c7b09009403d$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $5cacaf716aa5a0bc$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $7697c7b09009403d$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $062c87faab13cf69$export$8960430cfd85939f = Math.max;
var $062c87faab13cf69$export$96ec731ed4dcb222 = Math.min;
var $062c87faab13cf69$export$2077e0241d6afd3c = Math.round;



function $551069376f72598b$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $968046ff61357403$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $551069376f72598b$export$2e2bcd8739ae039)());
}


function $63725a25c9bcf322$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $5cacaf716aa5a0bc$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $062c87faab13cf69$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $062c87faab13cf69$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $5cacaf716aa5a0bc$export$45a5e7f76e0caa8d)(element) ? (0, $7697c7b09009403d$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $968046ff61357403$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $9a89276abeb2a1ed$export$2e2bcd8739ae039(node) {
    var win = (0, $7697c7b09009403d$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $2542bc92bba13ec0$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $b08948d76b5e4027$export$2e2bcd8739ae039(node) {
    if (node === (0, $7697c7b09009403d$export$2e2bcd8739ae039)(node) || !(0, $5cacaf716aa5a0bc$export$1b3bfaa9684536aa)(node)) return (0, $9a89276abeb2a1ed$export$2e2bcd8739ae039)(node);
    else return (0, $2542bc92bba13ec0$export$2e2bcd8739ae039)(node);
}


function $bb9c95a4233d0a40$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $2c4ef0e9f44b60bb$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $5cacaf716aa5a0bc$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $decbd7132d485f65$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $63725a25c9bcf322$export$2e2bcd8739ae039)((0, $2c4ef0e9f44b60bb$export$2e2bcd8739ae039)(element)).left + (0, $9a89276abeb2a1ed$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $dfa0fa749455460f$export$2e2bcd8739ae039(element) {
    return (0, $7697c7b09009403d$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $a1a69b399e4c99e1$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $dfa0fa749455460f$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $53fce9618bafb56b$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $062c87faab13cf69$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $062c87faab13cf69$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $53fce9618bafb56b$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $5cacaf716aa5a0bc$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $5cacaf716aa5a0bc$export$1b3bfaa9684536aa)(offsetParent) && $53fce9618bafb56b$var$isElementScaled(offsetParent);
    var documentElement = (0, $2c4ef0e9f44b60bb$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $63725a25c9bcf322$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $bb9c95a4233d0a40$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $a1a69b399e4c99e1$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $b08948d76b5e4027$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $5cacaf716aa5a0bc$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $63725a25c9bcf322$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $decbd7132d485f65$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $2bea23e7be8349a2$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $63725a25c9bcf322$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $a757d130ea87bdb4$export$2e2bcd8739ae039(element) {
    if ((0, $bb9c95a4233d0a40$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $5cacaf716aa5a0bc$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $2c4ef0e9f44b60bb$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $fbf5327fa84a17f9$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $bb9c95a4233d0a40$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $5cacaf716aa5a0bc$export$1b3bfaa9684536aa)(node) && (0, $a1a69b399e4c99e1$export$2e2bcd8739ae039)(node)) return node;
    return $fbf5327fa84a17f9$export$2e2bcd8739ae039((0, $a757d130ea87bdb4$export$2e2bcd8739ae039)(node));
}





function $b25add65b8f0c1de$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $fbf5327fa84a17f9$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $7697c7b09009403d$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $a1a69b399e4c99e1$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($b25add65b8f0c1de$export$2e2bcd8739ae039((0, $a757d130ea87bdb4$export$2e2bcd8739ae039)(target)));
}







function $05dd814afe27efbb$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $bb9c95a4233d0a40$export$2e2bcd8739ae039)(element)) >= 0;
}




function $6fb226e88d9c1af2$var$getTrueOffsetParent(element) {
    if (!(0, $5cacaf716aa5a0bc$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $dfa0fa749455460f$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $6fb226e88d9c1af2$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $551069376f72598b$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $551069376f72598b$export$2e2bcd8739ae039)());
    if (isIE && (0, $5cacaf716aa5a0bc$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $dfa0fa749455460f$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $a757d130ea87bdb4$export$2e2bcd8739ae039)(element);
    if ((0, $5cacaf716aa5a0bc$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $5cacaf716aa5a0bc$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $bb9c95a4233d0a40$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $dfa0fa749455460f$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $6fb226e88d9c1af2$export$2e2bcd8739ae039(element) {
    var window = (0, $7697c7b09009403d$export$2e2bcd8739ae039)(element);
    var offsetParent = $6fb226e88d9c1af2$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $05dd814afe27efbb$export$2e2bcd8739ae039)(offsetParent) && (0, $dfa0fa749455460f$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $6fb226e88d9c1af2$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $bb9c95a4233d0a40$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $bb9c95a4233d0a40$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $dfa0fa749455460f$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $6fb226e88d9c1af2$var$getContainingBlock(element) || window;
}


var $9dd33b3329bfd4d8$export$1e95b668f3b82d = 'top';
var $9dd33b3329bfd4d8$export$40e543e69a8b3fbb = 'bottom';
var $9dd33b3329bfd4d8$export$79ffe56a765070d2 = 'right';
var $9dd33b3329bfd4d8$export$eabcd2c8791e7bf4 = 'left';
var $9dd33b3329bfd4d8$export$dfb5619354ba860 = 'auto';
var $9dd33b3329bfd4d8$export$aec2ce47c367b8c3 = [
    $9dd33b3329bfd4d8$export$1e95b668f3b82d,
    $9dd33b3329bfd4d8$export$40e543e69a8b3fbb,
    $9dd33b3329bfd4d8$export$79ffe56a765070d2,
    $9dd33b3329bfd4d8$export$eabcd2c8791e7bf4
];
var $9dd33b3329bfd4d8$export$b3571188c770cc5a = 'start';
var $9dd33b3329bfd4d8$export$bd5df0f255a350f8 = 'end';
var $9dd33b3329bfd4d8$export$390fd549c5303b4d = 'clippingParents';
var $9dd33b3329bfd4d8$export$d7b7311ec04a3e8f = 'viewport';
var $9dd33b3329bfd4d8$export$ae5ab1c730825774 = 'popper';
var $9dd33b3329bfd4d8$export$ca50aac9f3ba507f = 'reference';
var $9dd33b3329bfd4d8$export$368f9a87e87fa4e1 = /*#__PURE__*/ $9dd33b3329bfd4d8$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $9dd33b3329bfd4d8$export$b3571188c770cc5a,
        placement + "-" + $9dd33b3329bfd4d8$export$bd5df0f255a350f8
    ]);
}, []);
var $9dd33b3329bfd4d8$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($9dd33b3329bfd4d8$export$aec2ce47c367b8c3, [
    $9dd33b3329bfd4d8$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $9dd33b3329bfd4d8$export$b3571188c770cc5a,
        placement + "-" + $9dd33b3329bfd4d8$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $9dd33b3329bfd4d8$export$421679a7c3d56e = 'beforeRead';
var $9dd33b3329bfd4d8$export$aafa59e2e03f2942 = 'read';
var $9dd33b3329bfd4d8$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $9dd33b3329bfd4d8$export$c65e99957a05207c = 'beforeMain';
var $9dd33b3329bfd4d8$export$f22da7240b7add18 = 'main';
var $9dd33b3329bfd4d8$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $9dd33b3329bfd4d8$export$8d4d2d70e7d46032 = 'beforeWrite';
var $9dd33b3329bfd4d8$export$68d8715fc104d294 = 'write';
var $9dd33b3329bfd4d8$export$70a6e5159acce2e6 = 'afterWrite';
var $9dd33b3329bfd4d8$export$d087d3878fdf71d5 = [
    $9dd33b3329bfd4d8$export$421679a7c3d56e,
    $9dd33b3329bfd4d8$export$aafa59e2e03f2942,
    $9dd33b3329bfd4d8$export$6964f6c886723980,
    $9dd33b3329bfd4d8$export$c65e99957a05207c,
    $9dd33b3329bfd4d8$export$f22da7240b7add18,
    $9dd33b3329bfd4d8$export$bab79516f2d662fe,
    $9dd33b3329bfd4d8$export$8d4d2d70e7d46032,
    $9dd33b3329bfd4d8$export$68d8715fc104d294,
    $9dd33b3329bfd4d8$export$70a6e5159acce2e6
];


function $f276ba44368dfd8e$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $f276ba44368dfd8e$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $f276ba44368dfd8e$var$order(modifiers); // order based on phase
    return (0, $9dd33b3329bfd4d8$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $52821211a7705205$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $c538aa7087fa253a$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $dd817d82a2733261$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $dd817d82a2733261$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $dd817d82a2733261$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $dd817d82a2733261$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $dd817d82a2733261$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $5cacaf716aa5a0bc$export$45a5e7f76e0caa8d)(reference) ? (0, $b25add65b8f0c1de$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $b25add65b8f0c1de$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $b25add65b8f0c1de$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $f276ba44368dfd8e$export$2e2bcd8739ae039)((0, $c538aa7087fa253a$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$dd817d82a2733261$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $53fce9618bafb56b$export$2e2bcd8739ae039)(reference, (0, $6fb226e88d9c1af2$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $2bea23e7be8349a2$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $52821211a7705205$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$dd817d82a2733261$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $dd817d82a2733261$export$8f7491d57c8f97a9 = /*#__PURE__*/ $dd817d82a2733261$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $9cdc9edba4f98ce7$var$passive = {
    passive: true
};
function $9cdc9edba4f98ce7$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $7697c7b09009403d$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $9cdc9edba4f98ce7$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $9cdc9edba4f98ce7$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $9cdc9edba4f98ce7$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $9cdc9edba4f98ce7$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $9cdc9edba4f98ce7$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $9cdc9edba4f98ce7$var$effect,
    data: {}
};



function $7a2425bd6d7b6bd7$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $9dcecf77bc33a23e$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $98929ee92366544a$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $c580ed563b0d92d0$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $7a2425bd6d7b6bd7$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $9dcecf77bc33a23e$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $9dd33b3329bfd4d8$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $9dd33b3329bfd4d8$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $9dd33b3329bfd4d8$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $9dd33b3329bfd4d8$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $98929ee92366544a$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $9dd33b3329bfd4d8$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $9dd33b3329bfd4d8$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $9924c6773254025e$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $c580ed563b0d92d0$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $9924c6773254025e$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $9924c6773254025e$var$popperOffsets,
    data: {}
};










var $97a627b2f360f15d$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $97a627b2f360f15d$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $062c87faab13cf69$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $062c87faab13cf69$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $97a627b2f360f15d$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $9dd33b3329bfd4d8$export$eabcd2c8791e7bf4);
    var sideY = (0, $9dd33b3329bfd4d8$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $6fb226e88d9c1af2$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $7697c7b09009403d$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $2c4ef0e9f44b60bb$export$2e2bcd8739ae039)(popper);
            if ((0, $dfa0fa749455460f$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $9dd33b3329bfd4d8$export$1e95b668f3b82d) || (placement === (0, $9dd33b3329bfd4d8$export$eabcd2c8791e7bf4) || placement === (0, $9dd33b3329bfd4d8$export$79ffe56a765070d2)) && variation === (0, $9dd33b3329bfd4d8$export$bd5df0f255a350f8)) {
            sideY = (0, $9dd33b3329bfd4d8$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $9dd33b3329bfd4d8$export$eabcd2c8791e7bf4) || (placement === (0, $9dd33b3329bfd4d8$export$1e95b668f3b82d) || placement === (0, $9dd33b3329bfd4d8$export$40e543e69a8b3fbb)) && variation === (0, $9dd33b3329bfd4d8$export$bd5df0f255a350f8)) {
            sideX = (0, $9dd33b3329bfd4d8$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $97a627b2f360f15d$var$unsetSides);
    var _ref4 = roundOffsets === true ? $97a627b2f360f15d$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $7697c7b09009403d$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $97a627b2f360f15d$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $7a2425bd6d7b6bd7$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $9dcecf77bc33a23e$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $97a627b2f360f15d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $97a627b2f360f15d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $97a627b2f360f15d$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $97a627b2f360f15d$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $7bfa183cbbd50017$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $5cacaf716aa5a0bc$export$1b3bfaa9684536aa)(element) || !(0, $bb9c95a4233d0a40$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $7bfa183cbbd50017$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $5cacaf716aa5a0bc$export$1b3bfaa9684536aa)(element) || !(0, $bb9c95a4233d0a40$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7bfa183cbbd50017$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $7bfa183cbbd50017$var$applyStyles,
    effect: $7bfa183cbbd50017$var$effect,
    requires: [
        'computeStyles'
    ]
};


var $ae71dd16ee0f2f83$export$d34966752335dd47 = [
    (0, $9cdc9edba4f98ce7$export$2e2bcd8739ae039),
    (0, $9924c6773254025e$export$2e2bcd8739ae039),
    (0, $97a627b2f360f15d$export$2e2bcd8739ae039),
    (0, $7bfa183cbbd50017$export$2e2bcd8739ae039)
];
var $ae71dd16ee0f2f83$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $dd817d82a2733261$export$ed5e13716264f202)({
    defaultModifiers: $ae71dd16ee0f2f83$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


const $c2ac01c42bd70b67$var$GOOD = "&#x2713";
const $c2ac01c42bd70b67$var$BAD = "&#x2717";
const $c2ac01c42bd70b67$var$UNKNOWN = "?";
const $c2ac01c42bd70b67$var$PING_SUCCESS = "success";
const $c2ac01c42bd70b67$var$PING_NO_RESPONSE_YET = "no response"; // noresponse in css
const $c2ac01c42bd70b67$var$PING_NO_CONNECTION = "no connection"; // noconnection in css
const $c2ac01c42bd70b67$var$PING_TIMEOUT = "timeout";
const $c2ac01c42bd70b67$var$MILLIS_PER_SECOND = 1000;
const $c2ac01c42bd70b67$var$PERIODIC_TEST_PERIOD = 30 * $c2ac01c42bd70b67$var$MILLIS_PER_SECOND;
const $c2ac01c42bd70b67$var$WEBRTC_RETRY_PERIOD = 10 * $c2ac01c42bd70b67$var$MILLIS_PER_SECOND;
const $c2ac01c42bd70b67$var$RECONNECT_WEBRTC_PERIOD = 1800 * $c2ac01c42bd70b67$var$MILLIS_PER_SECOND;
const $c2ac01c42bd70b67$var$TIMEOUTS_BEFORE_RECONNECT = 5;
const $c2ac01c42bd70b67$var$PING_TIMEOUT_MS = 5000;
const $c2ac01c42bd70b67$var$HIGH_LATENCY_MARK_MS = 500;
// == State ==
const $c2ac01c42bd70b67$var$tests = {
    http: $c2ac01c42bd70b67$var$UNKNOWN,
    dns: $c2ac01c42bd70b67$var$UNKNOWN,
    browser: $c2ac01c42bd70b67$var$UNKNOWN,
    webRtc: $c2ac01c42bd70b67$var$UNKNOWN,
    // We assume the internet is working at first since we do not allow the
    // browser to cache this page
    initialLoad: $c2ac01c42bd70b67$var$GOOD
};
// timestamp in millis of next periodic test
let $c2ac01c42bd70b67$var$nextPeriodicTests = Date.now();
let $c2ac01c42bd70b67$var$rtcPeer = null;
let $c2ac01c42bd70b67$var$rtcChannel = null;
// The timestamp of the first ping we sent to this peer
let $c2ac01c42bd70b67$var$millisOfFirstPingToPeer = null;
// The current server's own reported human description of location
let $c2ac01c42bd70b67$var$rtcPeerLocation = null;
// List of all peer connection locations we have connected to and when we connected to
// them (in *seconds* since first ping).
const $c2ac01c42bd70b67$var$rtcPeerLocations = [];
// Timestamp of the last time we attempted to connect
let $c2ac01c42bd70b67$var$lastRtcConnectAttempt = 0;
let $c2ac01c42bd70b67$var$timeoutsWithoutSuccess = 0;
// index 0 in pingResults is this timestamp
// each additional is the next
let $c2ac01c42bd70b67$var$secondOfFirstPing = 0;
// each entry is the latency of the ping or a string if an error
const $c2ac01c42bd70b67$var$pingResults = [];
// Used to ensure the Last RTT is not overwritten with an older response.
let $c2ac01c42bd70b67$var$lastSuccessPingMillis = null;
// Used to only run the DNS tests once.
var $c2ac01c42bd70b67$var$firstTest = true;
let $c2ac01c42bd70b67$var$maxPing = NaN;
let $c2ac01c42bd70b67$var$minPing = NaN;
// Used to compute average round trip time and packet loss.
let $c2ac01c42bd70b67$var$totalRoundTripTime = 0;
let $c2ac01c42bd70b67$var$numSuccessfulPings = 0;
let $c2ac01c42bd70b67$var$numTimeoutPings = 0;
// Holding this to allow for background timers more frequently than once per
// second which prevents gaps in ping requests on at least Firefox
const $c2ac01c42bd70b67$var$AudioContext = window.AudioContext || window.webkitAudioContext;
const $c2ac01c42bd70b67$var$audioContext = (()=>{
    if ($c2ac01c42bd70b67$var$AudioContext) return new $c2ac01c42bd70b67$var$AudioContext();
})();
// The second div that is currently or most recently display the tooltip
let $c2ac01c42bd70b67$var$tooltipTarget = null;
function $c2ac01c42bd70b67$var$getLastPingTime() {
    return $c2ac01c42bd70b67$var$secondOfFirstPing + $c2ac01c42bd70b67$var$pingResults.length;
}
// Careful, may return a negative number
function $c2ac01c42bd70b67$var$timeSinceFirstPing(sec) {
    return sec - $c2ac01c42bd70b67$var$secondOfFirstPing;
}
function $c2ac01c42bd70b67$var$getPingResultForSecond(sec) {
    const timeSinceFirst = $c2ac01c42bd70b67$var$timeSinceFirstPing(sec);
    if (timeSinceFirst < 0) return "Before first ping";
    return $c2ac01c42bd70b67$var$pingResults[$c2ac01c42bd70b67$var$timeSinceFirstPing(sec)];
}
function $c2ac01c42bd70b67$var$getPingPeerLocationForSecond(pingSec) {
    for(let idx = $c2ac01c42bd70b67$var$rtcPeerLocations.length - 1; idx >= 0; idx--){
        const [location_description, locSec] = $c2ac01c42bd70b67$var$rtcPeerLocations[idx];
        if (locSec <= pingSec) return location_description;
    }
    return "Unknown";
}
const $c2ac01c42bd70b67$var$tooltip = document.getElementById("tooltip");
function $c2ac01c42bd70b67$var$showTooltip(evt) {
    const div = evt.target;
    $c2ac01c42bd70b67$var$tooltipTarget = div;
    setTimeout(()=>{
        if ($c2ac01c42bd70b67$var$tooltipTarget !== div) // We moved away before the timeout
        return;
        const secInMinute = parseInt(div.getAttribute("data-sec"));
        const min = parseInt(div.parentElement.getAttribute("data-minute"));
        const timestampSec = min * 60 + secInMinute;
        const result = $c2ac01c42bd70b67$var$getPingResultForSecond(timestampSec);
        let text = new Date(timestampSec * $c2ac01c42bd70b67$var$MILLIS_PER_SECOND).toLocaleTimeString() + "<br>";
        if (typeof result === "number") {
            text += "Success: " + result.toFixed(1) + " ms<br>";
            text += "From: " + $c2ac01c42bd70b67$var$getPingPeerLocationForSecond(timestampSec);
        } else if (result === $c2ac01c42bd70b67$var$PING_NO_CONNECTION) text += "Establishing a connection...";
        else if (result === $c2ac01c42bd70b67$var$PING_NO_RESPONSE_YET) text += "Waiting for response...";
        else if (result === $c2ac01c42bd70b67$var$PING_TIMEOUT) text += "Timed out waiting for response";
        else // Future second
        return;
        $c2ac01c42bd70b67$var$tooltip.innerHTML = text;
        (0, $ae71dd16ee0f2f83$export$8f7491d57c8f97a9)(div, $c2ac01c42bd70b67$var$tooltip);
        $c2ac01c42bd70b67$var$tooltip.setAttribute("data-show", "");
    }, 40);
}
function $c2ac01c42bd70b67$var$hideTooltip() {
    $c2ac01c42bd70b67$var$tooltipTarget = null;
    $c2ac01c42bd70b67$var$tooltip.removeAttribute("data-show");
}
function $c2ac01c42bd70b67$var$createNewPingingRow(sec) {
    const row = document.createElement("div");
    row.classList.add("row");
    const date = new Date(sec * $c2ac01c42bd70b67$var$MILLIS_PER_SECOND);
    const toPaddedStr = (x)=>x.toString().padStart(2, "0");
    const minuteLabel = document.createElement("div");
    minuteLabel.classList.add("minuteLabel");
    minuteLabel.textContent = toPaddedStr(date.getHours()) + ":" + toPaddedStr(date.getMinutes());
    row.append(minuteLabel);
    for(let i = 0; i < 60; i++){
        const sec = document.createElement("div");
        sec.classList.add("sec");
        sec.classList.add("future");
        sec.setAttribute("data-sec", String(i));
        const showEvents = [
            "mouseenter",
            "focus"
        ];
        showEvents.forEach((event)=>{
            sec.addEventListener(event, $c2ac01c42bd70b67$var$showTooltip);
        });
        const hideEvents = [
            "mouseleave",
            "blur"
        ];
        hideEvents.forEach((event)=>{
            sec.addEventListener(event, $c2ac01c42bd70b67$var$hideTooltip);
        });
        row.append(sec);
    }
    const chart = document.getElementById("pingChart");
    chart.prepend(row);
    return row;
}
function $c2ac01c42bd70b67$var$setPingResultForSecond(sentMillis, result, nowMillis = Date.now()) {
    const elapsed = nowMillis - sentMillis;
    const sec = $c2ac01c42bd70b67$var$millisToWholeSec(sentMillis);
    if ($c2ac01c42bd70b67$var$secondOfFirstPing === 0) $c2ac01c42bd70b67$var$secondOfFirstPing = sec;
    if (result !== $c2ac01c42bd70b67$var$PING_NO_RESPONSE_YET) $c2ac01c42bd70b67$var$log("ping at", new Date(sentMillis).toISOString(), "had result", result, "in", elapsed + "ms");
    let toSave = result;
    if (result === $c2ac01c42bd70b67$var$PING_SUCCESS) toSave = elapsed;
    const previousResult = $c2ac01c42bd70b67$var$pingResults[$c2ac01c42bd70b67$var$timeSinceFirstPing(sec)];
    $c2ac01c42bd70b67$var$pingResults[$c2ac01c42bd70b67$var$timeSinceFirstPing(sec)] = toSave;
    // POSIX Unix timestamp days are guaranteed to be 86400.
    const minutesSinceEpoch = Math.floor(sec / 60);
    const id = "minute" + minutesSinceEpoch;
    let row = document.getElementById(id);
    if (row === null) {
        row = $c2ac01c42bd70b67$var$createNewPingingRow(sec);
        row.id = id;
        row.setAttribute("data-minute", String(minutesSinceEpoch));
    }
    const block = row.querySelector("[data-sec='" + sec % 60 + "']");
    if (block.classList.contains("future") || block.classList.contains("noresponse")) {
        block.classList.remove("future");
        block.classList.remove("noresponse");
        block.classList.add(result.replace(/ /gi, ""));
    }
    if (result == $c2ac01c42bd70b67$var$PING_SUCCESS) {
        const latencyLine = document.createElement("div");
        latencyLine.classList.add("latencyLine");
        const percent = Math.min(Math.max(elapsed / $c2ac01c42bd70b67$var$HIGH_LATENCY_MARK_MS, 0), 1.0);
        // We hard code the height in CSS to be 3em.
        const marginTop = (1 - percent) * 3;
        latencyLine.style.marginTop = "calc(" + marginTop + "em - 2px)";
        block.appendChild(latencyLine);
    }
    if (result == $c2ac01c42bd70b67$var$PING_SUCCESS) {
        if (previousResult === $c2ac01c42bd70b67$var$PING_TIMEOUT) // This is a late result. Undo the earlier timeout count.
        {
            if ($c2ac01c42bd70b67$var$numTimeoutPings > 0) $c2ac01c42bd70b67$var$numTimeoutPings++;
        }
        $c2ac01c42bd70b67$var$updatePingStatsOnSuccess(sentMillis, nowMillis);
    } else if (result == $c2ac01c42bd70b67$var$PING_TIMEOUT) $c2ac01c42bd70b67$var$updatePingStatsOnTimeout();
    // update summary
    let recentSuccess = false;
    for(let i = Math.max(0, $c2ac01c42bd70b67$var$pingResults.length - 3); i < $c2ac01c42bd70b67$var$pingResults.length; i++)if (typeof $c2ac01c42bd70b67$var$pingResults[i] === "number") {
        recentSuccess = true;
        break;
    }
    // Do not count a failure unless we have attempted a few times.
    if (recentSuccess || $c2ac01c42bd70b67$var$pingResults.length > 5) $c2ac01c42bd70b67$var$updateStatus("webRtc", recentSuccess ? $c2ac01c42bd70b67$var$GOOD : $c2ac01c42bd70b67$var$BAD);
}
const $c2ac01c42bd70b67$var$lastRoundTripTimeSpan = document.getElementById("lastRTT");
const $c2ac01c42bd70b67$var$averageRoundTripTimeSpan = document.getElementById("avgRTT");
const $c2ac01c42bd70b67$var$minRoundTripTimeSpan = document.getElementById("minRTT");
const $c2ac01c42bd70b67$var$maxRoundTripTimeSpan = document.getElementById("maxRTT");
function $c2ac01c42bd70b67$var$updatePingStatsOnSuccess(sentMillis, receivedMillis) {
    let rtt = receivedMillis - sentMillis;
    if (sentMillis > receivedMillis) // Or should we skip counting this?
    rtt = 0;
    if (isNaN($c2ac01c42bd70b67$var$minPing) || rtt < $c2ac01c42bd70b67$var$minPing) $c2ac01c42bd70b67$var$minPing = rtt;
    if (isNaN($c2ac01c42bd70b67$var$maxPing) || rtt > $c2ac01c42bd70b67$var$maxPing) $c2ac01c42bd70b67$var$maxPing = rtt;
    $c2ac01c42bd70b67$var$totalRoundTripTime += rtt;
    $c2ac01c42bd70b67$var$numSuccessfulPings++;
    if (!$c2ac01c42bd70b67$var$lastSuccessPingMillis || sentMillis >= $c2ac01c42bd70b67$var$lastSuccessPingMillis) {
        $c2ac01c42bd70b67$var$lastRoundTripTimeSpan.innerHTML = Math.round(rtt) + " ms";
        $c2ac01c42bd70b67$var$lastSuccessPingMillis = sentMillis;
    }
    const avgRTT = Math.round($c2ac01c42bd70b67$var$totalRoundTripTime / $c2ac01c42bd70b67$var$numSuccessfulPings);
    $c2ac01c42bd70b67$var$averageRoundTripTimeSpan.innerHTML = avgRTT + " ms";
    $c2ac01c42bd70b67$var$minRoundTripTimeSpan.innerHTML = Math.round($c2ac01c42bd70b67$var$minPing) + " ms";
    $c2ac01c42bd70b67$var$maxRoundTripTimeSpan.innerHTML = Math.round($c2ac01c42bd70b67$var$maxPing) + " ms";
    $c2ac01c42bd70b67$var$updatePacketLossSpan();
}
function $c2ac01c42bd70b67$var$updatePingStatsOnTimeout() {
    $c2ac01c42bd70b67$var$numTimeoutPings++;
    $c2ac01c42bd70b67$var$updatePacketLossSpan();
}
const $c2ac01c42bd70b67$var$packetLossSpan = document.getElementById("packetLoss");
function $c2ac01c42bd70b67$var$updatePacketLossSpan() {
    const total = $c2ac01c42bd70b67$var$numSuccessfulPings + $c2ac01c42bd70b67$var$numTimeoutPings;
    if (total == 0) return;
    const percent = ($c2ac01c42bd70b67$var$numTimeoutPings / total * 100).toFixed(2);
    $c2ac01c42bd70b67$var$packetLossSpan.innerHTML = String(percent) + "%";
}
function $c2ac01c42bd70b67$var$log(...varargs) {
    Function.prototype.bind.call(console.log, console).apply(this, varargs);
}
function $c2ac01c42bd70b67$var$changeSummaryText(state) {
    let newText;
    if (state === "on") newText = "Your internet is <strong>online</strong>";
    else if (state === "off") newText = "Your internet is <strong>offline</strong>";
    else if (state === "unknown") newText = "Your internet is likely <strong>experiencing issues</strong>";
    else {
        newText = "Internal error on pinging. Please report";
        console.error("This is a bug. Please report.");
    }
    const summaryText = document.getElementById("summaryText");
    summaryText.innerHTML = newText;
}
function $c2ac01c42bd70b67$var$updateStatus(which, newState) {
    if ($c2ac01c42bd70b67$var$tests[which] === newState) return;
    $c2ac01c42bd70b67$var$tests[which] = newState;
    document.getElementById(which + "Status").innerHTML = $c2ac01c42bd70b67$var$tests[which];
    let good = 0;
    let bad = 0;
    const check = (name)=>{
        const s = $c2ac01c42bd70b67$var$tests[name];
        if (s == $c2ac01c42bd70b67$var$GOOD) good++;
        else if (s == $c2ac01c42bd70b67$var$BAD) bad++;
    };
    check("http");
    check("dns");
    check("webRtc");
    if (good > 0 && bad > 0) $c2ac01c42bd70b67$var$changeSummaryText("unknown");
    else if (good > 0) $c2ac01c42bd70b67$var$changeSummaryText("on");
    else if (bad > 0) $c2ac01c42bd70b67$var$changeSummaryText("off");
    else if ($c2ac01c42bd70b67$var$secondOfFirstPing != 0 && $c2ac01c42bd70b67$var$timeSinceFirstPing($c2ac01c42bd70b67$var$millisToWholeSec(Date.now())) > $c2ac01c42bd70b67$var$millisToWholeSec($c2ac01c42bd70b67$var$PING_TIMEOUT_MS)) // Do not set to unknown for the first few seconds
    $c2ac01c42bd70b67$var$changeSummaryText("unknown");
}
function $c2ac01c42bd70b67$var$updateBrowserOnlineStatus() {
    $c2ac01c42bd70b67$var$log("browser check reports ", navigator.onLine ? "online" : "offline");
    $c2ac01c42bd70b67$var$updateStatus("browser", navigator.onLine ? $c2ac01c42bd70b67$var$GOOD : $c2ac01c42bd70b67$var$BAD);
    $c2ac01c42bd70b67$var$runPeriodicTests();
}
window.addEventListener("online", $c2ac01c42bd70b67$var$updateBrowserOnlineStatus);
window.addEventListener("offline", $c2ac01c42bd70b67$var$updateBrowserOnlineStatus);
$c2ac01c42bd70b67$var$updateBrowserOnlineStatus();
async function $c2ac01c42bd70b67$var$testHttpOrDns(testName) {
    console.assert(testName == "dns" || testName == "http");
    const isHttpTest = testName == "http";
    const randomNumber = Math.round(Math.random() * 10000000);
    const startTime = Date.now();
    let pong;
    if (isHttpTest) pong = fetch("/api/ping", {
        method: "POST",
        body: randomNumber.toString(),
        cache: "no-store"
    });
    else pong = fetch("https://" + randomNumber + "dns-check." + window.location.hostname + "/api/dns-check", {
        method: "GET",
        cache: "no-store"
    });
    try {
        const body = await (await pong).text();
        if (body !== randomNumber.toString()) throw "Returned body not expected";
        const duration = Date.now() - startTime;
        $c2ac01c42bd70b67$var$log(testName.toUpperCase(), "test completed successfully in", duration + "ms");
        $c2ac01c42bd70b67$var$updateStatus(testName, $c2ac01c42bd70b67$var$GOOD);
    } catch (error) {
        const duration = Date.now() - startTime;
        $c2ac01c42bd70b67$var$log(testName.toUpperCase(), "test FAILED in", duration + "ms");
        console.error(error);
        $c2ac01c42bd70b67$var$updateStatus(testName, $c2ac01c42bd70b67$var$BAD);
    }
}
function $c2ac01c42bd70b67$var$runPeriodicTests() {
    $c2ac01c42bd70b67$var$updateStatus("http", $c2ac01c42bd70b67$var$UNKNOWN);
    $c2ac01c42bd70b67$var$testHttpOrDns("http");
    if ($c2ac01c42bd70b67$var$firstTest) {
        $c2ac01c42bd70b67$var$updateStatus("dns", $c2ac01c42bd70b67$var$UNKNOWN);
        $c2ac01c42bd70b67$var$testHttpOrDns("dns");
        $c2ac01c42bd70b67$var$firstTest = false;
    }
    if ($c2ac01c42bd70b67$var$nextPeriodicTests <= Date.now()) $c2ac01c42bd70b67$var$nextPeriodicTests = Date.now() + $c2ac01c42bd70b67$var$PERIODIC_TEST_PERIOD;
}
function $c2ac01c42bd70b67$var$runPeriodicTestsIfNecessaryAndUpdateTimer(nowMillis) {
    if (nowMillis >= $c2ac01c42bd70b67$var$nextPeriodicTests) $c2ac01c42bd70b67$var$runPeriodicTests();
    const secondsLeft = Math.ceil(($c2ac01c42bd70b67$var$nextPeriodicTests - nowMillis) / 1000);
    const span = document.getElementById("timeUntilNextPeriodicTests");
    if (span.textContent != String(secondsLeft)) span.textContent = String(secondsLeft);
}
async function $c2ac01c42bd70b67$var$setupRtc() {
    if ($c2ac01c42bd70b67$var$lastRtcConnectAttempt + $c2ac01c42bd70b67$var$WEBRTC_RETRY_PERIOD > Date.now()) // Do not retry too quickly.
    return;
    if ($c2ac01c42bd70b67$var$rtcChannel) $c2ac01c42bd70b67$var$rtcChannel.close();
    if ($c2ac01c42bd70b67$var$rtcPeer) $c2ac01c42bd70b67$var$rtcPeer.close();
    if (!RTCPeerConnection) {
        $c2ac01c42bd70b67$var$log("No RTCPeerConnection");
        document.getElementById("no-webrtc").style.display = "initial";
        return;
    }
    $c2ac01c42bd70b67$var$log("Attempting to connect via WebRTC");
    $c2ac01c42bd70b67$var$rtcPeer = new RTCPeerConnection();
    $c2ac01c42bd70b67$var$rtcPeerLocation = null;
    $c2ac01c42bd70b67$var$millisOfFirstPingToPeer = null;
    $c2ac01c42bd70b67$var$rtcChannel = $c2ac01c42bd70b67$var$rtcPeer.createDataChannel("webudp", {
        ordered: false,
        maxRetransmits: 0
    });
    $c2ac01c42bd70b67$var$lastRtcConnectAttempt = Date.now();
    $c2ac01c42bd70b67$var$rtcChannel.binaryType = "arraybuffer";
    $c2ac01c42bd70b67$var$rtcChannel.onerror = (evt)=>{
        $c2ac01c42bd70b67$var$log("Failed to establish WebRTC channel");
    };
    $c2ac01c42bd70b67$var$rtcChannel.onmessage = function(evt) {
        $c2ac01c42bd70b67$var$onPingResponse(evt);
    };
    const offer = await $c2ac01c42bd70b67$var$rtcPeer.createOffer();
    await $c2ac01c42bd70b67$var$rtcPeer.setLocalDescription(offer);
    const response = await fetch("/new_rtc_session?num_successful=" + $c2ac01c42bd70b67$var$numSuccessfulPings.toString() + "&num_timeout=" + $c2ac01c42bd70b67$var$numTimeoutPings.toString(), {
        method: "POST",
        body: $c2ac01c42bd70b67$var$rtcPeer.localDescription.sdp
    });
    const resp_json = await response.json();
    await $c2ac01c42bd70b67$var$rtcPeer.setRemoteDescription(new RTCSessionDescription(resp_json.answer));
    var candidate = new RTCIceCandidate(resp_json.candidate);
    await $c2ac01c42bd70b67$var$rtcPeer.addIceCandidate(candidate);
}
$c2ac01c42bd70b67$var$setupRtc();
function $c2ac01c42bd70b67$var$millisToWholeSec(millis) {
    return Math.floor(millis / $c2ac01c42bd70b67$var$MILLIS_PER_SECOND);
}
function $c2ac01c42bd70b67$var$sendPing(nowMillis) {
    if (!$c2ac01c42bd70b67$var$rtcChannel || $c2ac01c42bd70b67$var$rtcChannel.readyState !== "open") {
        $c2ac01c42bd70b67$var$setPingResultForSecond(nowMillis, $c2ac01c42bd70b67$var$PING_NO_CONNECTION);
        $c2ac01c42bd70b67$var$setupRtc();
        return;
    }
    // We grab a new timestamp to keep the ping latency as accurate as we can from
    // JS.
    let data = "";
    if (!$c2ac01c42bd70b67$var$rtcPeerLocation) data += "LOC?\n";
    const now = Date.now();
    data += String(now);
    $c2ac01c42bd70b67$var$rtcChannel.send(data);
    if ($c2ac01c42bd70b67$var$millisOfFirstPingToPeer === null) $c2ac01c42bd70b67$var$millisOfFirstPingToPeer = now;
    // Send before setting NO_RESPONSE_YET since setPingResultForSecond might be
    // slow if it has to add a new row.
    $c2ac01c42bd70b67$var$setPingResultForSecond(nowMillis, $c2ac01c42bd70b67$var$PING_NO_RESPONSE_YET);
    // TODO it would be nice to not use a timeout here since the page might be in
    // the background and it seems we only get 1 timer per second. Or maybe we
    // should cancel the timer.
    setTimeout(()=>{
        if ($c2ac01c42bd70b67$var$getPingResultForSecond($c2ac01c42bd70b67$var$millisToWholeSec(nowMillis)) === $c2ac01c42bd70b67$var$PING_NO_RESPONSE_YET) {
            $c2ac01c42bd70b67$var$setPingResultForSecond(nowMillis, $c2ac01c42bd70b67$var$PING_TIMEOUT);
            $c2ac01c42bd70b67$var$timeoutsWithoutSuccess++;
            if ($c2ac01c42bd70b67$var$timeoutsWithoutSuccess >= $c2ac01c42bd70b67$var$TIMEOUTS_BEFORE_RECONNECT) $c2ac01c42bd70b67$var$setupRtc();
        }
    }, $c2ac01c42bd70b67$var$PING_TIMEOUT_MS);
}
// Attempt to use an event provided timestamp to get a timestamp that is closer
// to when we received the response packet.
function $c2ac01c42bd70b67$var$getEventTimestamp(evt, nowMillis, sentMillis) {
    if (!evt.timeStamp || !performance.timeOrigin) {
        console.debug("No event time");
        return nowMillis;
    }
    const eventStamp = performance.timeOrigin + evt.timeStamp;
    // The event stamp can be rounded for privacy so only use it if it is older
    // than the timestamp we grabbed.
    if (eventStamp > nowMillis) {
        console.debug("Event time in the future", sentMillis, eventStamp, nowMillis);
        return nowMillis;
    }
    // It also seems to be wrong in some browsers (Firefox on Android) where it is
    // an hour behind so only use it if it isn't before the timestamp we sent the
    // request.
    if (eventStamp < sentMillis) {
        console.debug("Event time too far in past", sentMillis, eventStamp, nowMillis);
        return nowMillis;
    }
    return eventStamp;
}
function $c2ac01c42bd70b67$var$onPingResponse(evt) {
    // Get our timestamp as early as possible to reduce latency calculation error
    const nowMillis = Date.now();
    const lines = evt.data.split("\n");
    // Last line is the timestamp we sent in the request.
    const sentMillis = parseInt(lines.pop());
    // The other lines are metadata
    for (const line of lines)// Currently the only known possibility is LOC which is the server location
    if (line.startsWith("LOC:\t")) {
        const newRtcPeerLocation = line.split(":\t")[1];
        if ($c2ac01c42bd70b67$var$rtcPeerLocation === null) {
            $c2ac01c42bd70b67$var$rtcPeerLocation = newRtcPeerLocation;
            if ($c2ac01c42bd70b67$var$rtcPeerLocations.length == 0 || $c2ac01c42bd70b67$var$rtcPeerLocations[$c2ac01c42bd70b67$var$rtcPeerLocations.length - 1][0] != $c2ac01c42bd70b67$var$rtcPeerLocation) $c2ac01c42bd70b67$var$rtcPeerLocations.push([
                $c2ac01c42bd70b67$var$rtcPeerLocation,
                $c2ac01c42bd70b67$var$millisToWholeSec($c2ac01c42bd70b67$var$millisOfFirstPingToPeer)
            ]);
            const pingLocationSpan = document.getElementById("pingLocation");
            pingLocationSpan.innerHTML = $c2ac01c42bd70b67$var$rtcPeerLocation;
        } else if (newRtcPeerLocation != $c2ac01c42bd70b67$var$rtcPeerLocation) console.error("rtcPeerLocation does not match existing:", newRtcPeerLocation, $c2ac01c42bd70b67$var$rtcPeerLocation);
    }
    const receivedMillis = $c2ac01c42bd70b67$var$getEventTimestamp(evt, nowMillis, sentMillis);
    $c2ac01c42bd70b67$var$timeoutsWithoutSuccess = 0;
    $c2ac01c42bd70b67$var$setPingResultForSecond(sentMillis, $c2ac01c42bd70b67$var$PING_SUCCESS, receivedMillis);
    if ($c2ac01c42bd70b67$var$lastRtcConnectAttempt + $c2ac01c42bd70b67$var$RECONNECT_WEBRTC_PERIOD <= Date.now()) {
        $c2ac01c42bd70b67$var$log("Reconnecting WebRTC connection in case the server connection info has updated.");
        $c2ac01c42bd70b67$var$setupRtc();
    }
}
function $c2ac01c42bd70b67$var$sendPingIfNecessary(nowMillis) {
    if ($c2ac01c42bd70b67$var$millisToWholeSec(nowMillis) >= $c2ac01c42bd70b67$var$getLastPingTime()) $c2ac01c42bd70b67$var$sendPing(nowMillis);
}
function $c2ac01c42bd70b67$var$onTimer() {
    let nowMillis = Date.now();
    $c2ac01c42bd70b67$var$runPeriodicTestsIfNecessaryAndUpdateTimer(nowMillis);
    $c2ac01c42bd70b67$var$sendPingIfNecessary(nowMillis);
    nowMillis = Date.now();
    const waitMillis = 1005 - nowMillis % 1000;
    window.setTimeout($c2ac01c42bd70b67$var$onTimer, waitMillis);
}
$c2ac01c42bd70b67$var$onTimer();


//# sourceMappingURL=app.bd544d4a.js.map
